function SkeletonList({ Component, amount }) {
  return (
    Array(amount || 3).fill().map(() => (
      <Component />
    ))
  );
}

export default SkeletonList;
